angular.module('rings-translate', ['pascalprecht.translate'])
	.config(function ($translateProvider) {
	  $translateProvider.translations('en', {
	    "ADMINISTRATION": 'Administration',
	    "ADVANCED.SEARCH" : 'Advanced search options',
	    "ADVANCED.SEARCH.DATE" : 'Date',
	    "ADVANCED.SEARCH.RINGNUMBER" : 'Ring/Mark number',
	    "ADVANCED.SEARCH.SPECIES" : 'Species',
	    "ADVANCED.SEARCH.SEX" : 'Sex',
	    "ADVANCED.SEARCH.SEX.N" : 'Unknown',
	    "ADVANCED.SEARCH.SEX.M" : 'Male',
	    "ADVANCED.SEARCH.SEX.F" : 'Female',
	    "ADVANCED.SEARCH.AGE" : 'Age',
	    "ADVANCED.SEARCH.AGE.UNKNOWN" : 'Age unknown',
	    "ADVANCED.SEARCH.LOCATION" : 'Location',
	    "ALULA.NOT.SET": 'All values of Alula must be set',
	    'CIRCUMSTANCES.NOT.SET': 'Circumstances are not set',
	    'COUNTRY.NOT.SET': 'Country or region is not set',
	    "CRDS": 'Coordinates',
	    "CRDS.ACCURACY": 'Accuracy of coordinates',
	    "CRDS.FORMAT": 'Incorrect format of coordinates!',
	    "CRDS.GET": 'Click to map to get coordinates',
	    "CRDS.NOT.SET": 'Coordinates are not set or are in incorrect format',
	    "ERROR": 'Error',
	    "ERROR.AUTH": 'Welcome to RINGS - application for management of bird ringing data. Please log in to use it.',
	    "ERROR.INACTIVE": 'Your account is inactive, contact site administrator',
	    'DATE.NOT.SET': 'Date is not set, or is in incorrect format',
	    'DATE.FUTURE': 'Date is in future',
	    "DATE.ACCURACY": 'Accuracy of date',
	    'DATE.RINGING': 'Date ringing',
	    'DATE.RETRAP': 'Date retrap',
	    "DAYS": 'Days',
	    "DETAILFORM.ADDRESS" : 'Address',
	    "DETAILFORM.BIRTHDAY" : 'Birth day',
	    "DETAILFORM.CITY" : 'City',
	    "DETAILFORM.COUNTRY" : 'Country',
	    "DETAILFORM.MAIL" : 'E-mail',
	    "DETAILFORM.ENTER.ADDRESS" : 'Enter address',
	    "DETAILFORM.ENTER.CITY" : 'Enter city',
	    "DETAILFORM.ENTER.FIRSTNAME" : 'Enter first name',
	    "DETAILFORM.ENTER.MAIL" : 'Enter e-mail',
	    "DETAILFORM.ENTER.FIRSTNAME" : 'Enter first name',
	    "DETAILFORM.ENTER.SURNAME" : 'Enter last name',
	    "DETAILFORM.ENTER.ZIPCODE" : 'Enter zipcode',
	    "DETAILFORM.FIRSTNAME" : 'First name',
	    "DETAILFORM.INCORRECT.BIRTHDAY" : 'Incorrect date format',
	    "DETAILFORM.INCORRECT.MAIL" : 'Incorrect format of provided e-mail',
	    "DETAILFORM.INCORRECT.ZIPCODE" : 'Zipcode must be provided as 5 digit number',
	    "DETAILFORM.LICENCENUMBER" : 'Ringing licence number',
	    "DETAILFORM.PHONE" : 'Phone',
	    "DETAILFORM.SURNAME" : 'Last name',
	    "DETAILFORM.HEADER" : 'Contact information',
	    "DETAILFORM.TITLE" : 'Title',
	    "DETAILFORM.ZIPCODE" : 'Zipcode',
	    "DISTANCE": 'Distance',
	    "FOREIGN": "Foreign ringing scheme",
	    "FOREIGN.HOME": "My account",
	    "FROM": 'From',
	    "HOME": 'Main page',
	    "HOME.TITLE": "Rings",
	    "HOME.P1": "The application for collecting and maintaining the data about ringed birds.",
	    "HOME.P2": "Set up and managed in co-operation of the Ringing Centre of the National Museum, the Society of Collaborators of the Ringing Centre of the National Museum and the Czech Society for Ornithology",	
	    "INCORRECT_NAME": 'Username or password are incorrect', 
	    "INCORRECT.DATE.FORMAT": 'Incorrect time format', 
	    "INCORRECT.DATE.FROM.TO": 'Date FROM is bigger than date TO', 
	    'INSERT.OBSERVATION': 'Insert observation',
	    "LOADING": 'Loading', 
	    "LOADING.CODEBOOK" : 'Loading codebook', 
	    "LOGGED": 'Logged as:',
	    'MARKCOLOR.NOT.SET': 'Color of additional mark is not set',
	    'MARKTYPE.NOT.SET': 'Mark identification is not set',
	    "LOGOUT": 'Logout',
	    "NAME": 'Name',
	    "NRRECORDS": 'Number of records',
	    "OBSFORM.ABOVETARSUS": 'Definitely above tarsus',
	    "OBSFORM.ONTARSUS": 'Definitely on tarsus',
	    "OBSFORM.ADD.MARK": 'Add identification mark',
	    "OBSFORM.ALULA": 'Alula',
	    "OBSFORM.BILL.LENGTH": 'Bill length (mm)',
	    "OBSFORM.BILL.METHOD": 'Bill method',
	    "OBSFORM.BIRDINFO": 'Info about bird',
	    "OBSFORM.BROODPATCH": 'Brood patch',
	    "OBSFORM.CARPAL": 'Carpal covert',
	    "OBSFORM.CARPAL.NEW": 'New',
	    "OBSFORM.CARPAL.OLD": 'Old',
	    "OBSFORM.CATCHINGMETHOD": 'Catching method',
	    "OBSFORM.CATCHINGLURE": 'Catching lure',
	    "OBSFORM.CIRCUMSTANCES": 'Circumstances',
	    "OBSFORM.CIRCUMSTANCES.DETAILED": 'Circumstances - in detail',
	    "OBSFORM.COLOR": 'Color',
	    "OBSFORM.CONDITION": 'Condition',
	    "OBSFORM.COOBSERVERS": 'Observed by',
	    "OBSFORM.HINDCLAW": 'Hind claw (mm)',
	    "OBSFORM.FAT": 'Fat score',
	    "OBSFORM.HEAD.LENGTH": 'Total head length (mm)',
	    "OBSFORM.INFO": 'Ring information',
	    "OBSFORM.LOCATION": 'Location',
	    "OBSFORM.MANIPULATED": 'Manipulated',
	    "OBSFORM.MARKINFO": 'Ring/mark information',
	    "OBSFORM.MARKTYPE": 'Identification method',
	    "OBSFORM.MASS": 'Mass (g)',
	    "OBSFORM.METHOD.SEX": 'Sexing method',
	    "OBSFORM.MOULT": 'Moult',
	    "OBSFORM.MOVED": 'Moved before encounter',
	    "OBSFORM.MUNICIPALITY": 'Municipality',
	    "OBSFORM.OGC": 'Old greater coverts',
	    "OBSFORM.PECTORAL": 'Pectoral muscle score',
	    "OBSFORM.PLUMAGECODE": 'Plumage code',
	    "OBSFORM.PRIMARYMOULT": 'Primary moult',
	    "OBSFORM.SECONDARYMOULT": 'Secondary moult',
	    "OBSFORM.PULLUSACCURACY": 'Pullus age accuracy',
	    "OBSFORM.PULLUSAGE": 'Pullus age (days)',
	    "OBSFORM.REGION": 'Region',	 
	    "OBSFORM.REMOVE.MARK": 'Remove identification mark',
	    "OBSFORM.RINGINFORMATION": 'Ring Information',	
	    "OBSFORM.RINGPOSITION": 'Placement of ring/mark',   
	    "OBSFORM.SCHEME": 'Ringing Scheme',	
	    "OBSFORM.STATEOFWINGPOINT": 'State of wing point',
	    "OBSFORM.USER": 'Observation owner',
	    "OBSFORM.STATUS": 'Status',  
	    "OBSFORM.TAIL.LENGTH": 'Tail length (mm)', 
	    "OBSFORM.TAIL.DIFFERENCE": 'Tail difference (mm)',
	    "OBSFORM.TARSUS": 'Tarsus (mm)',
	    "OBSFORM.TARSUS.METHOD": 'Tarsus method',
	    "OBSFORM.THIRDPRIMARY": 'Third primary (mm)',
	    "OBSFORM.WINGLENGTH": 'Wing length (mm)', 
	    "PARTIAL.MATCH": 'Partial match',
	    "PARTIAL.MATCH.TOOLTIP": 'Return rings/marks, which include provided code, but are not an exact match',
	    "PASSWORD": 'Password',
	    "PRIMARYMOULT.NOT.SET": 'All values of Primary moult must be set',
	    "SECONDARYMOULT.NOT.SET": 'All values of Secondary moult must be set',
	    "PWDFORM.CONFIRM" : 'Confirm password',
	    "PWDFORM.ENTER.CONFIRM" : 'Confirm new password',
	    "PWDFORM.ENTER.NEW" : 'Enter new password',
	    "PWDFORM.ENTER.OLD" : 'Enter password',
	    "PWDFORM.NEW" : 'New password',
	    "PWDFORM.INCORRECT" : 'Incorrect password',
	    "PWDFORM.NO.MATCH" : 'Old and new passwords do not match',
	    "PWDFORM.OLD" : 'Old Password',
	    "PWDFORM.SHORT" : 'Password is too short',
	    "PWDFORM.TITLE" : 'Change password',
	    "RETRAP.FROM" : 'Date (retrap) from',
	    "RETRAP.TO" : 'Date (retrap) to',
	    "RINGER": 'Ringer',
	    "RINGNUMBER": 'Ring/Mark number',
	    "RINGNUMBER.NOT.SET": 'Mark number not set',
	    "RESET.FORM": 'Reset form',
	    "RETRAPS": 'Retraps',
	    "SAVE": 'Save',
	    "SAVE.OK": 'Data were succesfully saved',
	    "SAVE.ERROR": 'There was an error while savind the data',
	    "SAVING.DATA": 'Saving data',
	    "SEARCH": 'Search',
	    "SEX.NOT.SET": 'Sex is not set',
	    "SITE.RINGING": 'Ringing site',
	    "SITE.RETRAP": 'Retrap site',
	    "SPECIES": 'Species',
	    "SPECIES.NOT.SET": 'Species must be set by selecting it from list.',
	    "TIME": 'Time',
	    "TO": 'To',
	    "UPDATE": 'Save changes'
	  });
	  $translateProvider.translations('cz', {
	    "ADMINISTRATION" : 'Administrace',
	    "ADVANCED.SEARCH" : 'Rozšířené možnosti vyhledávání',
	    "ADVANCED.SEARCH.DATE" : 'Datum',
	    "ADVANCED.SEARCH.RINGNUMBER" : 'Číslo kroužku/značky',
	    "ADVANCED.SEARCH.SPECIES" : 'Druh',
	    "ADVANCED.SEARCH.SEX" : 'Pohlaví',
	    "ADVANCED.SEARCH.SEX.N" : 'N - Neznámé',
	    "ADVANCED.SEARCH.SEX.M" : 'M - Samec',
	    "ADVANCED.SEARCH.SEX.F" : 'F - Samice',
	    "ADVANCED.SEARCH.AGE" : 'Věk',
	    "ADVANCED.SEARCH.AGE.UNKNOWN" : 'Věk neznámý',
	    "ADVANCED.SEARCH.LOCATION" : 'Místo',
	    "ALULA.NOT.SET": 'Všechny hodnoty pole Alula musí být vyplněny',
	    'CIRCUMSTANCES.NOT.SET': 'Pole okolnosti je povinné',
	    'COUNTRY.NOT.SET': 'Není vyplněna země nebo region',
	    "CRDS": 'Souřadnice',
	    "CRDS.ACCURACY": 'Přesnot zaznamenání polohy',
	    "CRDS.FORMAT": 'Formát souřadnic není platný!',
	    "CRDS.GET": 'Kliknutím do mapy vyberte lokalitu',
	    "CRDS.NOT.SET": 'Souřadnice musí být vyplněny a musí se jednat o čísla!',
	    'DATE.FUTURE': 'Nelze zadat datum z budoucnosti!',
	    'DATE.NOT.SET': 'Není vyplněno datum, nebo je v nesprávném formátu',
	    'DATE.RINGING': 'Dat. krouž.',
	    'DATE.RETRAP': 'Dat. nálezu',
	    "DAYS": 'Dní',
	    "DETAILFORM.ADDRESS" : 'Kontaktní adresa',
	    "DETAILFORM.BIRTHDAY" : 'Datum narození',
	    "DETAILFORM.CITY" : 'Město',
	    "DETAILFORM.COUNTRY" : 'Země',
	    "DETAILFORM.MAIL" : 'E-mail',
	    "DETAILFORM.ENTER.ADDRESS" : 'Zadejte ulici a číslo',
	    "DETAILFORM.ENTER.CITY" : 'Zadejte město',
	    "DETAILFORM.ENTER.FIRSTNAME" : 'Zadejte jméno',
	    "DETAILFORM.ENTER.MAIL" : 'Zadejte E-mailovou adresu',
	    "DETAILFORM.ENTER.FIRSTNAME" : 'Zadejte jméno',
	    "DETAILFORM.ENTER.SURNAME" : 'Zadejte příjmení',
	    "DETAILFORM.ENTER.ZIPCODE" : 'Zadejte PSČ',
	    "DETAILFORM.FIRSTNAME" : 'Jméno',
	    "DETAILFORM.INCORRECT.BIRTHDAY" : 'Nesprávný formát data. Zadejte datum ve formátu "den.měsíc.rok"',
	    "DETAILFORM.INCORRECT.MAIL" : 'Zadaná adresa je v nesprávném formátu',
	    "DETAILFORM.INCORRECT.ZIPCODE" : 'PSČ musí být zadáno jako 5 číslic bez mezer',
	    "DETAILFORM.LICENCENUMBER" : 'Číslo kroužkovací licence',
	    "DETAILFORM.PHONE" : 'Telefon',
	    "DETAILFORM.SURNAME" : 'Příjmení',
	    "DETAILFORM.HEADER" : 'Kontaktní informace',
	    "DETAILFORM.TITLE" : 'Titul',
	    "DETAILFORM.ZIPCODE" : 'PSČ',
	    "DATE.ACCURACY": 'Přesnot zaznamenání data',
	    "DISTANCE": 'Vzdálenost',
	    "ERROR": 'Chyba',
	    "ERROR.AUTH": 'Dobrý den, vítá vás aplikace RINGS pro vkládání záznamů o okroužkovaných ptácích. Pro přihlášení zadejte své uživatelské jméno a heslo',
	    "ERROR.INACTIVE": 'Váš uživateslký účet není aktivní, obraťte se na kroužkovací stanici',
	    "FOREIGN": "Zahraniční centrála",
	    "FOREIGN.HOME": "Můj účet",
	    "FROM": 'Od',
	    "HOME": "Úvod",
	    "HOME.TITLE": "Rings",
	    "HOME.P1": "Aplikace pro správu údajů o kroužkování ptáků.",
	    "HOME.P2": "Aplikace RINGS byla vyvinuta ve spolupráci Kroužkovací stanice Národního muzea, Společnosti spolupracovníků KS NM a České společnosti ornitologické",	
	    "INCORRECT_NAME": 'Uživatelské jméno nebo heslo jsou chybně zadány',
	    "INCORRECT.DATE.FROM.TO": 'Datum OD je větší než datum DO', 
	    'INSERT.OBSERVATION': 'Vložit pozorování',
	    "LOADING": 'Načítání', 
	    "LOADING.CODEBOOK": 'Načítání číselníku', 
	    "LOGGED": 'Přihlášen:',
	    "LOGOUT": 'Odhlásit',
	    'MARKTYPE.NOT.SET': 'Není vyplněn typ značky/kroužku',
	    'MARKCOLOR.NOT.SET': 'Barva přídatné identifikační značky musí být vyplněna',
	    "NAME": 'Jméno',
	    "NRRECORDS": 'Počet záznamů',
	    "OBSFORM.ABOVETARSUS": 'Určitě nad tarsus',
	    "OBSFORM.ONTARSUS": 'Určitě na tarsus',
	    "OBSFORM.ADD.MARK": 'Přidat identifikační značku/kroužek',
	    "OBSFORM.ALULA": 'Alula',
	    "OBSFORM.BILL.LENGTH": 'Délka zobáku (mm)',
	    "OBSFORM.BILL.METHOD": 'Způsob měření zobáku',
	    "OBSFORM.BIRDINFO": 'Info o jedinci',
	    "OBSFORM.BROODPATCH": 'Hnízdní nažina',
	    "OBSFORM.CARPAL": 'Zápěstní krovka',
	    "OBSFORM.CARPAL.NEW": 'Nová',
	    "OBSFORM.CARPAL.OLD": 'Stará',
	    "OBSFORM.CATCHINGMETHOD": 'Metoda odchytu',
	    "OBSFORM.CATCHINGLURE": 'Metoda lákání',
	    "OBSFORM.CES": 'Záznam po pro projekt CES',
	    "OBSFORM.CES.PROJECT": 'Číslo projektu CES',
	    "OBSFORM.CES.NUMBER": 'Číslo odchytu CES',
	    "OBSFORM.CES.HABITAT": 'Habitat CES',
	    "OBSFORM.CES.NETLENGTH": 'Délka sítí',
	    "OBSFORM.CES.TIME": 'Čas odchytu',
	    "OBSFORM.CES.MOULT": 'Pelichání CES',
	    "OBSFORM.CES.NETNUMBER": 'Číslo sítě',
	    "OBSFORM.CIRCUMSTANCES": 'Okolnosti',
	    "OBSFORM.CIRCUMSTANCES.DETAILED": 'Okolnosti - podrobně',
	    "OBSFORM.COLOR": 'Barva',
	    "OBSFORM.CONDITION": 'Kondice',
	    "OBSFORM.COOBSERVERS": 'Pozoroval/a',
	    "OBSFORM.FAT": 'Tuk',
	    "OBSFORM.HINDCLAW": 'Zadní dráp (mm)',
	    "OBSFORM.HEAD.LENGTH": 'Celková délka hlavy (mm)',
	    "OBSFORM.INFO": 'Úkon',
	    "OBSFORM.LOCATION": 'Lokalita',
	    "OBSFORM.MANIPULATED": 'Manipulace',
	    "OBSFORM.MARKINFO": 'Info o kroužku/značce',
	    "OBSFORM.MARKTYPE": 'Typ',
	    "OBSFORM.MASS": 'Hmotnost',
	    "OBSFORM.METHOD.SEX": 'Metoda určení pohlaví',
	    "OBSFORM.MOULT": 'Pelichání',
	    "OBSFORM.MOVED": "Přemístění před nálezem/ohlášením",
	    "OBSFORM.MUNICIPALITY": 'Obec',
	    "OBSFORM.OGC": 'Staré LK',
	    "OBSFORM.PECTORAL": 'Prsní svaly',
	    "OBSFORM.PLUMAGECODE": 'Kódy jednotlivých šatů',
		"OBSFORM.PRIMARYMOULT": 'Pelichání RL',
		"OBSFORM.SECONDARYMOULT": 'Pelichání LL',
		"OBSFORM.PULLUSACCURACY": 'Přesnot zaznamenání věku pullus',
	    "OBSFORM.PULLUSAGE": 'Věk pullus (dny)',
	    "OBSFORM.REGION": 'Region',
	    "OBSFORM.REMOVE.MARK": 'Odebrat identifikační značku/kroužek',
	    "OBSFORM.RINGINFORMATION": 'Úkon',
	    "OBSFORM.RINGPOSITION": 'Pozice značky/kroužku',
	    "OBSFORM.SCHEME": 'Stanice',
	    "OBSFORM.STATEOFWINGPOINT": 'Stav vrcholu křídla',
	    "OBSFORM.USER": 'Pozorovatel',
	    "OBSFORM.STATUS": 'Status',
	    "OBSFORM.TAIL.LENGTH": 'Délka ocasu (mm)', 
	    "OBSFORM.TAIL.DIFFERENCE": 'Rozdíl délky RP (mm)',
	    "OBSFORM.TARSUS": 'Tarsus /běhák/ (mm)',
	    "OBSFORM.TARSUS.METHOD": 'Způsob měření běháku',
	    "OBSFORM.THIRDPRIMARY": 'Třetí ruční letka (mm)',
	    "OBSFORM.WINGLENGTH": 'Délka křídla (mm)',
	    "PARTIAL.MATCH": 'Částečná shoda',
	    "PARTIAL.MATCH.TOOLTIP": 'Částečná shoda vrátí i ty kroužky, které obsahují zadané číslo, ale nejedná se o přesnou shodu',
	    "PASSWORD": 'Heslo',
	    "PRIMARYMOULT.NOT.SET": 'Všechny hodnoty pole "Pelichání RL" musí být vyplněny',
	    "SECONDARYMOULT.NOT.SET": 'Všechny hodnoty pole "Pelichání LL" musí být vyplněny',
	    "PWDFORM.CONFIRM" : 'Potvrzení nového hesla',
	    "PWDFORM.ENTER.CONFIRM" : 'Zadejte potvrzení nového hesla',
	    "PWDFORM.ENTER.NEW" : 'Zadejte nové heslo',
	    "PWDFORM.ENTER.OLD" : 'Zadejte heslo',
	    "PWDFORM.NEW" : 'Nové heslo',
	    "PWDFORM.INCORRECT" : 'Nesprávné heslo',
	    "PWDFORM.NO.MATCH" : 'Neodpovídá novému heslu',
	    "PWDFORM.OLD" : 'Staré heslo',
	    "PWDFORM.SHORT" : 'Heslo je příliš krátké',
	    "PWDFORM.TITLE" : 'Změna hesla',
	    "RETRAP.FROM" : 'Datum (retrapu) od',
	    "RETRAP.TO" : 'Datum (retrapu) do',
	    "RINGER": 'Kroužkovatel',
	    "RINGNUMBER": 'Číslo kroužku/značky',
	    "RINGNUMBER.NOT.SET": 'Číslo kroužku/značky není vyplněno',
	    "RESET.FORM": 'Promazat formulář',
	    "RETRAPS": 'Zpětné odchyty',
	    "SAVE": 'Uložit',
	    "SAVE.ERROR": 'Při ukládání dat došlo k chybě',
	    "SAVE.OK": 'Data byla úspěšně uložena',
	    "SAVING.DATA": 'Ukládám data',
	    "SEARCH": 'Vyhledat',
	    "SEX.NOT.SET": 'Pohlaví musí být vyplněno',
	    "SITE.RINGING": 'Místo krouž.',
	    "SITE.RETRAP": 'Místo nálezu',
	    "SPECIES": 'Druh',
	    "SPECIES.NOT.SET": 'Druh musí být vyplněn. Vyberte ze seznamu, nikoli vepsáním názvu do textového pole',
	    "TIME": 'Čas',
	    "TO": 'Do',
	    "UPDATE": 'Uložit změny'
	  });
	  $translateProvider.preferredLanguage('cz');
	    // Tell the module to store the language in the cookie
	  $translateProvider.useCookieStorage();
	});